export const columns = ({ t }) => [
  { name: 'carrier', title: t('Carrier') },
  { name: 'prettyLevel', title: t('Level') },
  { name: 'prettyTransitTime', title: t('Transit Time') },
  { name: 'prettyEstimatedDelivery', title: t('Planned Delivery') },
  { name: 'shipToday', title: t('Ship Today?') },
  { name: 'route', title: t('Route') },
  { name: 'rate', title: t('Rate') },
  { name: 'type', title: ' ' }
];
